import { TEAMS } from "./teams";

export const DATE_RANGE_OPTIONS: Option[] = [
    {
      label: "2022 - 2023",
      value: "2022-2023",
    },
    {
      label: "2021 - 2022",
      value: "2021-2022",
    },
    {
      label: "2020 - 2021",
      value: "2020-2021",
    },
    {
      label: "2019 - 2020",
      value: "2019-2020",
    },
    {
      label: "2018 - 2019",
      value: "2018-2019",
    },
    {
      label: "2017 - 2018",
      value: "2017-2018",
    },
    {
      label: "2016 - 2017",
      value: "2016-2017",
    },
    {
      label: "2015 - 2016",
      value: "2015-2016",
    },
    {
      label: "2014 - 2015",
      value: "2014-2015",
    },
    {
      label: "2013 - 2014",
      value: "2013-2014",
    },
  ];
  export const ALL_WEEKS_OPTIONS: Option[] = [
    {
      label: "Week 11",
      value: "11",
    },
    {
      label: "Week 10",
      value: "10",
    },
    {
      label: "Week 9",
      value: "9",
    },
  ];
  export const ALL_YEARS_OPTIONS: Option[] = [
    {
      label: "2024 - 2025",
      value: "2024",
    },
    {
      label: "2023 - 2024",
      value: "2023",
    },
    {
      label: "2022 - 2023",
      value: "2022",
    },
    {
      label: "2021 - 2022",
      value: "2021",
    },
    {
      label: "2020 - 2021",
      value: "2020",
    },
  ];
  export const SEASON_OPTIONS: Option[] = [
    {
      label: "Pre Season",
      value: "pre-season",
    },
    {
      label: "Regular Season",
      value: "regular-season",
    },
    {
      label: "Post Season",
      value: "post-season",
    },
  ];
  
  export const VIEW_OPTIONS: Option[] = [
    {
      label: "League",
      value: "league",
    },
    {
      label: "Conference",
      value: "conference",
    },
    {
      label: "Division",
      value: "division",
    },
  ];

  export const ALL_TEAMS_OPTIONS: Option[] = [
    {
      label: "All Teams",
      value: "all",
    },
    ...TEAMS.map((team, _) => (
      {
        label: `${team.location} ${team.name}`,
        value: `${team.abbreviation}`,
      }
    ))
  ];